"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var SmallInlineFadeInSpinner_1 = require("../widgets/SmallInlineFadeInSpinner");
var LineageFilteredBar_1 = require("./LineageFilteredBar");
var LineageIconButton_1 = require("./LineageIconButton");
var LineageCartouche = /** @class */ (function (_super) {
    __extends(LineageCartouche, _super);
    function LineageCartouche() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineageCartouche.prototype.renderCartouche = function () {
        return (React.createElement(data_catalog_shared_1.CartoucheIconContainer, null, this.props.lineageItems.map(function (item) { return (React.createElement(LineageIconButton_1.LineageIconButton, { isCurrentPane: item.isCurrentPane, linkHref: item.linkHref, lineageItemType: item.lineageItemType, buttonAltText: item.buttonAltText, key: item.lineageItemType, inCartouche: true })); })));
    };
    LineageCartouche.prototype.renderContentInfoContainer = function () {
        return (React.createElement(data_catalog_shared_1.ContentInfoContainer, null, this.props.lineageItems.map(function (item) {
            return (React.createElement(react_router_dom_1.Link, { to: item.linkHref, className: data_catalog_shared_1.cartoucheContentInfoItemClass, key: item.lineageItemType },
                React.createElement(data_catalog_shared_1.LineageContentInfoItemLabelRow, null,
                    React.createElement("span", { className: data_catalog_shared_1.classes(item.isCurrentPane && data_catalog_shared_1.activeLineageItemClass), title: item.label }, item.label),
                    item.countLoading ? React.createElement(SmallInlineFadeInSpinner_1.SmallInlineFadeInSpinner, null) : null),
                React.createElement(data_catalog_shared_1.LineageContentInfoItemBarRow, null, React.createElement(LineageFilteredBar_1.LineageFilteredBar, { filteredCount: item.filteredCount, unfilteredCount: item.unfilteredCount }))));
        })));
    };
    LineageCartouche.prototype.render = function () {
        return (React.createElement(data_catalog_shared_1.CartoucheWrapper, null,
            this.renderCartouche(),
            this.renderContentInfoContainer()));
    };
    return LineageCartouche;
}(React.Component));
exports.LineageCartouche = LineageCartouche;
//# sourceMappingURL=LineageCartouche.js.map